<script setup lang="ts">
import type { AlbumListFilters } from "@/components/AlbumFiltersDrawer/types"
import { onMounted, reactive, watchEffect } from "vue"
import { Select } from "@/components/ui"
import DrawerReka from "@/components/ui/DrawerReka/DrawerReka.vue"
import { useTranslation } from "@/composables"

interface AlbumFiltersProps {
  open: boolean
  filters: AlbumListFilters
}

const props = defineProps<AlbumFiltersProps>()

const emit = defineEmits<{
  "update:filters": [filters: AlbumListFilters]
  "update:open": [value: boolean]
}>()

const { t } = useTranslation()

const filterDefaults: AlbumListFilters = {
  perPage: 10,
}

const internalFiltersState = reactive<AlbumListFilters>(structuredClone(filterDefaults))

onMounted(() => {
  if (props.filters?.perPage)
    internalFiltersState.perPage = props.filters.perPage
})

const perPageOptions = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "15", value: 15 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
]

watchEffect(() => {
  emit("update:filters", internalFiltersState)
})
</script>

<template>
  <DrawerReka :open="open" :title="t('filters')" @update:open="emit('update:open', $event)">
    <form>
      <div class="flex flex-col gap-4">
        <Select
          v-model="internalFiltersState.perPage"
          name="perPage"
          :label="t('host_dashboard_filters.per_page_label')"
          :items="perPageOptions"
        />
      </div>
    </form>
  </DrawerReka>
</template>
